import { Component, computed, inject, input } from '@angular/core';
import { MuiColor } from '../../utility';
import { MuiListItem } from './mui-list-item.component';


@Component({
  selector: 'mui-list-item-label',
  template: `
    <div class="mui-text-size--sm primary-text" [id]="labelId()">
      <b>{{ primary() }}</b>
    </div>
    @if (secondary(); as secondaryText) {
      <div [class]="'mui-text--' + secondaryTextColor()" class="mui-text-size--xs secondary-text">
        {{ secondaryText }}
      </div>
    }
  `,
  styleUrl: './mui-list-item-label.component.scss'
})
export class MuiListItemLabel {
  primary = input.required({ transform: (value: unknown) => value?.toString() || '' });
  secondary = input('', { transform: (value: unknown) => value?.toString() || '' });
  secondaryTextColor = input<MuiColor | string>(MuiColor.SECONDARY);

  protected item = inject(MuiListItem, { optional: true });
  protected labelId = computed(() => {
    return this.item ? this.item.id() + '_label' : null;
  });

}
